(function () {
    // Quantity selector logic
    const quantityContainer = document.querySelector(".quantity");
    if (quantityContainer) {
        const minusBtn = quantityContainer.querySelector(".minus");
        const plusBtn = quantityContainer.querySelector(".plus");
        const inputBox = quantityContainer.querySelector(".input-box");

        updateButtonStates();

        quantityContainer.addEventListener("click", handleButtonClick);
        inputBox.addEventListener("input", handleQuantityChange);

        function updateButtonStates() {
            const value = parseInt(inputBox.value, 10);
            minusBtn.disabled = value <= 1;
            plusBtn.disabled = value >= parseInt(inputBox.max, 10);
        }

        function handleButtonClick(event) {
            event.preventDefault();
            if (event.target.classList.contains("minus")) {
                decreaseValue();
            } else if (event.target.classList.contains("plus")) {
                increaseValue();
            }
        }

        function decreaseValue() {
            let value = parseInt(inputBox.value, 10);
            value = isNaN(value) ? 1 : Math.max(value - 1, 1);
            inputBox.value = value;
            updateButtonStates();
            handleQuantityChange();
        }

        function increaseValue() {
            let value = parseInt(inputBox.value, 10);
            value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(inputBox.max, 10));
            inputBox.value = value;
            updateButtonStates();
            handleQuantityChange();
        }

        function handleQuantityChange() {
            let value = parseInt(inputBox.value, 10);
            value = isNaN(value) ? 1 : value;
            console.log("Quantity changed:", value);
        }
    }

    // Denomination links sorting
    const denominationDiv = document.querySelector('.denomination');
    if (denominationDiv) {
        const links = Array.from(denominationDiv.querySelectorAll('a, span'));
        links.sort((a, b) => {
            const priceA = parseInt(a.dataset.price, 10);
            const priceB = parseInt(b.dataset.price, 10);
            return priceA - priceB;
        });
        links.forEach(link => denominationDiv.removeChild(link));
        links.forEach(link => denominationDiv.appendChild(link));
        denominationDiv.style.display = 'flex';
    }

    // Custom denomination input + Buy Now button
    const input = document.getElementById("customDenomination");
    const buyNowBtn = document.getElementById("buyNowBtn");
    const priceSpan = document.getElementById("ProductPriceSpan");

    function formatPrice(value) {
        return `${value},00`;
    }

    function validateDenomination() {
        const denomination = parseInt(input.value, 10);
        const isValid = !isNaN(denomination) && denomination >= 15 && denomination <= 500;
        buyNowBtn.disabled = !isValid;
        if (isValid) {
            priceSpan.textContent = formatPrice(denomination);
        }
    }

    if (input) {
        input.addEventListener("input", validateDenomination);
        validateDenomination();
    }

    if (buyNowBtn) {
        buyNowBtn.addEventListener("click", async function () {
            const denomination = parseInt(input.value, 10);

            // Enforce 5–500 range
            if (denomination < 15 || denomination > 500) {
                alert("Ungültiger Betrag. Bitte wählen Sie einen Betrag zwischen 15 und 500.");
                return;
            }

            // Derive generic handle: strip existing "-flex-[1-5]" suffix
            const currentHandle = window.productHandle;
            const match = currentHandle.match(/^(.*)-flex-[1-5]$/);
            if (!match) {
                console.error("Unerwarteter Produkt-Handle:", currentHandle);
                alert("Fehler: Ungültiger Produkt-Handle.");
                return;
            }
            const baseHandle = match[1];

            // Determine tier 1–5 (each 100 range, up to 500)
            const tier = Math.min(Math.ceil(denomination / 100), 5);
            const productHandle = `${baseHandle}-flex-${tier}`;

            try {
                // 2) Fetch product JSON
                res = await fetch(`/products/${productHandle}.json`);
                const productData = await res.json();

                // 3) Find matching variant by denomination (option1)
                const variant = productData.product.variants.find(v =>
                    parseInt(v.option1, 10) === denomination
                );
                if (!variant) {
                    alert("Kein passender Variant gefunden!");
                    return;
                }

                // 4) Add to cart
                res = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
                });
                if (!res.ok) {
                    const err = await res.json();
                    throw new Error(err.description || "Failed to add item to cart.");
                }

                // 5) Redirect to checkout
                window.location.href = "/checkout";
            } catch (error) {
                console.error("Error:", error);
                alert("Fehler: " + error.message);
            }
        });
    }

    // Clickable predefined denominations
    const priceSpans = document.querySelectorAll('.variable-denom span[data-price]');
    const customDenominationInput = document.getElementById('customDenomination');
    if (priceSpans) {
        priceSpans.forEach(span => {
            span.addEventListener('click', function () {
                customDenominationInput.value = this.dataset.price;
                validateDenomination();
            });
        });
    }

})();